<template>
<a-modal
    :zIndex="1052"
    v-bind:open="showModal"
    width="420px"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    footer
    :destroyOnClose="true"
    @cancel="closeModal"
    centered
    :title="$t('countrycode_modal_title')"
>
    <div class="country-code-modal">
        <div class="country-code-modal-body">
            <a-select
                v-model:value="selectedCountryCode"
                :options="availableCountryCodes"
                class="country-code-modal-select"
                :placeholder="$t('countrycode_modal_search_placeholder')"
                show-search
                :filter-option="filterOption"
                :not-found-content="null"
                :dropdown-style="{ zIndex: 1052 }"
            ></a-select>
            <a-button
                type="primary"
                @click="emitCountryCode"
            >
                {{ $t('countrycode_modal_confirm') }}
            </a-button>
        </div>
        <div class="country-code-modal-footer">
            <a-button
                @click="closeModal"
            >{{ $t('countrycode_modal_close') }}</a-button>
        </div>
    </div>
</a-modal>
</template>
<script>
import { oneBtnDialog } from '@/utils/utils';
import { buildFullCountryCodeList } from './enums/common';

const readonly = {
    closeModal: 'closeModal',
    emitCountryCode: 'emitCountryCode',
}

// (제거) 이 파일이 들고 있던 국가 목록 46개 — enums/common.js의 countryCodes와 완전히 동일한
// 중복 정의였고, 한쪽만 고치면 조용히 어긋나는 구조였다. 단일 원천에서 조립해 쓴다(2026-08-13).


export default {
    props: {
        certificateText: {
            type: String
        },
        showModal: {
            type: Boolean,
            required: true,
            default: false
        },
        currentCountryCode: {
            type: String,
            required: true,
            default: ''
        },
    },
    emits: [readonly.closeModal, readonly.emitCountryCode],
    data() {
        return {
            selectedCountryCode: undefined,
        }
    },
    computed: {
        // 전체 국가 목록 — 단일 원천(enums/common.js countryCodes)에서 조립.
        // computed라 locale을 바꾸면 국가명이 즉시 따라간다.
        availableCountryCodes() {
            return buildFullCountryCodeList(this.$t.bind(this));
        }
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                this.selectedCountryCode = undefined;
            }
        }
    },
    methods: {
        closeModal() {
            if(this.selectedCountryCode === 'ETC') {
                this.selectedCountryCode = this.currentCountryCode;
            }

            this.$emit(readonly.emitCountryCode, this.currentCountryCode);
            this.$emit(readonly.closeModal, 'countryCodeModal', false);
        },
        filterOption(input, option) {
            return (
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        async emitCountryCode() {
            if(!this.selectedCountryCode) {
                return await oneBtnDialog(
                    this.$t('countrycode_modal_none_selected_title'),
                    this.$t('countrycode_modal_none_selected_msg'),
                    false
                );
            }

            this.$emit(readonly.emitCountryCode, this.selectedCountryCode);
        },
    }
}
</script>
<style lang="scss" scoped>
.country-code-modal {
    width: 100%;
    .country-code-modal-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        padding: 20px;
        .country-code-modal-select {
            width: 100%;
        }
    }
    .country-code-modal-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px 20px 20px;
    }
}
</style>
